import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setAiOnlyEnabled } from 'app/redux/aiOnlyConfiguration/actions';
import { selectAiOnlyEnabledConfiguration } from 'app/redux/aiOnlyConfiguration/reducer';
import useAiOnlyPasswordProtection from 'app/utils/hooks/passwordProtection/useAiOnlyPasswordProtection';
import { Toggle } from 'rsuite';
import { useIntl } from 'react-intl';

export default function AiOnlyToggle() {
  const intl = useIntl();
  const aiOnlyEnabled = useSelector(selectAiOnlyEnabledConfiguration);
  const [requestValidation, modalComponent] = useAiOnlyPasswordProtection();
  const dispatch = useDispatch();

  const toggleConfiguration = useCallback(() => {
    requestValidation()
      .then(() => dispatch(setAiOnlyEnabled(!aiOnlyEnabled)))
      .catch(() => {});
  }, [dispatch, aiOnlyEnabled, requestValidation]);

  return (
    <>
      <Toggle
        checked={aiOnlyEnabled}
        size="lg"
        checkedChildren={intl.formatMessage({ id: 'general.ON' })}
        unCheckedChildren={intl.formatMessage({ id: 'general.OFF' })}
        onChange={toggleConfiguration}
      />
      {modalComponent}
    </>
  );
}
